import { ApiTenantProvider } from "@incendium/api";

export function apiTenantProviderToSamlPathSegment(
  provider: ApiTenantProvider,
): string {
  return String(provider)
    .replace(/^TenantProvider/i, "")
    .toLowerCase();
}

export function portalUrlAfterLogin(postLoginPath: string): string {
  const trimmed = (postLoginPath || "").trim();
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    return trimmed;
  }
  const path =
    trimmed === "" ? "/" : trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  const url = `${window.location.origin}${path}`;
  return url.endsWith("/") ? url.slice(0, -1) : url;
}
